import { SessionPreviewPointDto } from 'types/models/SessionsPageData';
import PlayerAvatar from 'components/ui/PlayerAvatar';
import { SessionCardItem } from './playerPerformanceUtils';
import SessionCardPreview from 'pages/Sessions/components/SessionCardPreview';
import { buildSessionPreview } from 'pages/Sessions/sessionPreview';

interface RecentSessionCardProps {
  card: SessionCardItem;
  /** Pre-translated pieces of the footer: session type, "24 kicks" and the date. */
  kindLabel: string;
  countLabel: string;
  dateLabel: string;
  /** Fallback when the card itself carries no preview points. */
  measurements: SessionPreviewPointDto[];
  onShowPerformance: () => void;
  onOpenSession: () => void;
}

const RecentSessionCard: React.FunctionComponent<RecentSessionCardProps> = ({ card, kindLabel, countLabel, dateLabel, measurements, onShowPerformance, onOpenSession }) => {
  const preview = buildSessionPreview(card.kind, card.previewPoints ?? measurements);
  return (
    <div className='pp-session-card-shell' data-test='pp-session-card'>
      <div className='pp-session-card'>
        <span className='pp-session-card-head'>
          <button
            type='button'
            className='pp-session-card-avatar-action'
            onClick={onShowPerformance}
            data-test='pp-session-card-avatar-action'
          >
            <PlayerAvatar name={card.playerName} imageUrl={card.avatarUrl} size='md' />
          </button>
          <button
            type='button'
            className='pp-session-card-name pp-session-card-name--action'
            onClick={onShowPerformance}
            data-test='pp-session-card-player-action'
          >
            {card.playerName}
          </button>
        </span>
        <div
          className='pp-session-card-preview pp-session-card-open'
          role='button'
          tabIndex={0}
          onClick={onOpenSession}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOpenSession(); } }}
          data-test='pp-session-card-open'
        >
          <SessionCardPreview mode={preview.mode} points={preview.points} reachableSegments={preview.reachableSegments} hideTopPoints={card.kind === 'Corner'} />
        </div>
        <button type='button' className='pp-session-card-foot' onClick={onOpenSession} data-test='pp-session-card-meta'>
          <span className={`pp-session-card-kind pp-session-card-kind--${card.kind}`}>{kindLabel}</span>
          <span className='pp-session-card-count'>{countLabel}</span>
          <span className='pp-session-card-date'>{dateLabel}</span>
        </button>
      </div>
    </div>
  );
};

export default RecentSessionCard;
